module.exports = __webpack_public_path__ + "img/ACRISURE_ITALIA_LOGO - Copia.c3119a6a.webp";